var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$route.params.contractId
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("header-view", {
                    attrs: { title: _vm.policyHolderName, icon: "ti-user" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.params.contractId && _vm.contract
        ? _c("ContractOverview", {
            staticClass: "mt-4",
            attrs: {
              contract: _vm.contract,
              contractCategories: _vm.contractCategories,
              policyHolder: _vm.policyHolder
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.params.contractId
        ? _c(
            "b-btn",
            {
              staticClass: "mt-4",
              attrs: {
                variant: "link",
                to: "/policyHolders/" + _vm.$route.params.id
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("message.policyHolderContracts.back")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$route.params.contractId
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                _vm._l(_vm.contractCategories, function(category) {
                  return _vm.getContractsByCategory(category.value).length > 0
                    ? _c(
                        "b-row",
                        { key: category.value, staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("ContractsCard", {
                                attrs: {
                                  collapseId: category.value + "Id",
                                  title: category.text,
                                  items: _vm.getContractsByCategory(
                                    category.value
                                  ),
                                  phView: false
                                },
                                on: { showDetails: _vm.onShowDetails }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                })
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-992f2e7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-992f2e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/policyholder/PolicyHolderContracts.vue
// module id = bVbc
// module chunks = 1